export default {
  props: {
    rule: {
      type: String,
      default: ''
    }
  },
  methods: {
    // 关闭弹窗
    closeDialogBtn() {
      this.$emit('listenToChildEvent');
    },
    // 透明壳返回端内
    backToNativeWithTransparent(url) {
      // const openapi
      //     = 'baidumap://map/cost_share?transparentWeb=0&navigationStatus=2&popRooot=no&hiddenBackBtn=0&hiddenTitle=1&url='
      //         + encodeURIComponent(url);
      // const options = {
      //     launchInNA: true, // 是否调起地图, 默认调起
      //     openapi: openapi, // 默认用cost_share调起当前页面
      //     // isDuer: false, // 度口令打开
      //     immediately: false // 若调起客户端失败，是否立即执行失败回调。默认2s后执行失败回调
      // };
      // common.openMapClient(options);
    },
    junmToService() {
      // 点击客服调起端
      // let url
      //     = 'baidumap://map/showfeedback?source=1&contactEnable=1&robotEnable=1&faqChannel=1&popRoot=no&src=school-season';
      // let urlBack = window.location.origin + window.location.pathname;
      // // if (common.plat.isNative) {
      // //     location.href = url;
      // // }
      // else {
      //     this.backToNativeWithTransparent(urlBack);
      // }
    }
  }
};